import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, Input, Popconfirm, Table } from "antd";

import "./stylesEditableTable.css";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false} style={{backgroundColor: 'red'}}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};
const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);
  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };
  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({
        ...record,
        ...values,
      });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };
  let childNode = children;
  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingInlineEnd: 24,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }
  return <td {...restProps}>{childNode}</td>;
};
const EditableTable = () => {
  const [dataSource, setDataSource] = useState([
    {
      key: "0",
      id: "1",
      name: "Peer to Peer",
      note: "There is an updated logo, so I changed it here",
      status: "Active",
      activity: true,
    },
    {
      key: "1",
      id: "2",
      name: "Feature Name",
      note: "-",
      status: "Active",
      activity: true,
    },
    {
      key: "2",
      id: "3",
      name: "Rewards",
      note: "-",
      status: "Disabled",
      activity: false,
    },
  ]);
  const [count, setCount] = useState(2);
  const handleDelete = (key) => {
    const newData = dataSource.filter((item) => item.key !== key);
    setDataSource(newData);
  };
  const defaultColumns = [
    {
      title: "ID",
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a,b) => a.name.localeCompare(b.name),
    },
    {
      title: "Note according to the update",
      dataIndex: "note",
      editable: true,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, record) => {
        return (
          <span
            className={`status ${
              record.status === "Active" ? "status-active" : "status-disabled"
            }`}
          >
            {record.status}
          </span>
        );
      },
    },
    {
      title: "Activity",
      dataIndex: "activity",
      render: (_, record) => {
        return (
          <ToggleSwitch
            status={record.activity ? 1 : 0}
            eventCode={1}
            updateEventCode={() => {}}
          />
        );
      },
    },
  ];

  const handleSave = (row) => {
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    };
  });
  return (
    <div className="edit-table">
      <Table
        components={components}
        rowClassName={() => "editable-row"}
        pagination={false}
        dataSource={dataSource}
        columns={columns}
      />
    </div>
  );
};
export default EditableTable;
